
export const dashboardWorker = {
  namespaced: true,
  state: {
    processSearch: null,
    finishedProcessSearch: null,
    invitationSearch: null
  },
  mutations: {
    storeWorkerProcessSearch(state, search) {
      state.processSearch = search;     
    },
    storeFinishedProcessSearch(state, search) {
      state.finishedProcessSearch = search;     
    },
    storeInvitationSearch(state, search) {
      state.invitationSearch = search;     
    }
  }
}
